exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media only screen and (max-width:767px){.kianGi .ui.cards{justify-content:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/Iah/Kong/其他建議.css
// module id = 665
// module chunks = 0